import MenuIcon from "@mui/icons-material/Menu";
import { Box, IconButton, Link, useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { RftButton } from "../../RftButton";
import {
    urlToAbout,
    urlToAbrasives,
    urlToAdhesive,
    urlToCatalogHome,
    urlToContactUs,
    urlToCoverageChart,
    urlToDocumentCenter,
    urlToFaqs,
    urlToFillers,
    urlToFinishes,
    urlToHome,
    urlToHowTo,
    urlToJanEquipment,
    urlToOils,
    urlToRentals,
    urlToRepairs,
    urlToReviews,
    urlToSealers,
    urlToSport,
    urlToStains,
    urlToTools,
    urlToWoodEquipment
} from "../../Routing";
import { MobileMenu } from "./MobileNavigation";
import { NavItem, NavLink, NavMenu } from "./Navigation";
import { CustAppreciationAnnouncement } from "../Announcements/CustAppreciation";

/**
 * The site-wide header
 */

const floorProducts = [
    { title: "Finishes", href: urlToFinishes },
    { title: "Sealers", href: urlToSealers },
    { title: "Stains &\nTranstints", href: urlToStains },
    { title: "Abrasives", href: urlToAbrasives },
    { title: "Sport\nFloor Products", href: urlToSport },
    { title: "Tools &\nAccsesories", href: urlToTools },
    { title: "Fillers", href: urlToFillers },
    { title: "Oils", href: urlToOils },
    { title: "Adhesives", href: urlToAdhesive }
];

const equipment = [
    { title: "Wood Floor\nEquipment", href: urlToWoodEquipment },
    { title: "Janitorial\nEquipment", href: urlToJanEquipment }
    // { title: "Repair", href: urlToRepairs },
    // { title: "Rental", href: urlToRentals },
];

const about = [
    { title: "About Us", href: urlToAbout },
    { title: "Reviews", href: urlToReviews }
];

const resources = [
    { title: "How To's", href: urlToHowTo },
    { title: "FAQs", href: urlToFaqs },
    { title: "Document Center", href: urlToDocumentCenter },
    { title: "Coverage Chart", href: urlToCoverageChart }
];

export const SiteHeader: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    if (isMobile) return <MobileHeader />;

    return (
        <>
            <FullHeader />
            <SlimHeader />
        </>
    );
};

const FullHeader: React.FC = () => {
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

    function handleHamburgerClick() {
        setMobileMenuVisible((prevState) => !prevState);
    }

    function handleOutsideMenuClick() {
        setMobileMenuVisible(false);
    }

    return (
        <div className="rft_header_outer">
            <div className="rft_header_inner" style={{ paddingTop: "24px" }}>
                <Grid container spacing={1} sx={{ width: "100%" }}>
                    <Grid
                        order={{ xs: 2, md: 1 }}
                        size={{ xs: 12, md: 3, lg: 4 }}
                        className="rft_header_left"
                        display="flex"
                        justifyContent="center"
                        alignSelf="center"
                        textAlign="center"
                        sx={{
                            display: { xs: "none", md: "flex" }
                        }}
                    >
                        <p>
                            pittsburgh floor supplies
                            <br />
                            412.449.0120
                        </p>
                    </Grid>
                    <Grid
                        order={{ xs: 1, md: 2 }}
                        size={{ xs: 12, md: 6, lg: 4 }}
                        display="flex"
                        className="rft_header_center"
                        justifyContent="center"
                        sx={{ position: "relative" }}
                    >
                        <div className="rft_mobile_hmenu_btn">
                            <IconButton
                                onClick={handleHamburgerClick}
                                aria-label="Mobile Menu Hamburger"
                            >
                                <MenuIcon
                                    sx={{ width: "40px", height: "40px" }}
                                />
                            </IconButton>
                        </div>
                        <div style={{ margin: "0 auto" }}>
                            <Link href={urlToHome} underline="none">
                                <h2 className="rft_header_title">
                                    Rossi Floor <br />
                                    Technologies
                                </h2>
                            </Link>
                        </div>
                    </Grid>
                    <Grid
                        order={{ xs: 3 }}
                        size={{ xs: 12, md: 3, lg: 4 }}
                        className="rft_header_right"
                        justifyContent="center"
                        alignSelf="center"
                        sx={{
                            display: { xs: "none", md: "flex" }
                        }}
                    >
                        <RftButton
                            href={urlToCatalogHome}
                            target="_blank"
                            variant="contained"
                            sx={{ width: "230px" }}
                        >
                            Shop Now
                        </RftButton>
                    </Grid>
                </Grid>
            </div>
            <div className="rft_divider"></div>

            {/* Desktop Navigation */}
            <DesktopNavMenu />

            {/* Mobile Navigation */}
            <MobileMenu
                open={mobileMenuVisible}
                onClose={handleOutsideMenuClick}
                floorProducts={floorProducts}
                equipment={equipment}
                about={about}
                resources={resources}
            />
        </div>
    );
};

const SlimHeader: React.FC = () => {
    const [isScrolled, setScrolled] = useState(false);
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            requestAnimationFrame(() => {
                if (window.pageYOffset > 180) {
                    console.log("scrolled");
                    setScrolled(true);
                } else if (window.pageYOffset < 100) {
                    setScrolled(false);
                }

                setScrollY(window.scrollY);
            });
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div
            className="rft_header_slim_container"
            style={{ top: scrollY > 230 ? 0 : scrollY - 230 }}
        >
            <div className="rft_header_slim">
                <div>
                    <Link href={urlToHome} underline="none">
                        <h2 className="rft_header_title">
                            Rossi Floor Technologies
                        </h2>
                    </Link>
                </div>
                <RftButton
                    href={urlToCatalogHome}
                    target="_blank"
                    variant="contained"
                    sx={{ width: "230px" }}
                >
                    Shop Now
                </RftButton>
            </div>
            <CustAppreciationAnnouncement />
        </div>
    );
};

const MobileHeader: React.FC = () => {
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

    function handleHamburgerClick() {
        setMobileMenuVisible((prevState) => !prevState);
    }

    function handleOutsideMenuClick() {
        setMobileMenuVisible(false);
    }

    return (
        <div className="rft_header_outer_mobile">
            <div className="rft_header_inner" style={{ paddingTop: "24px" }}>
                <Grid container spacing={1} sx={{ width: "100%" }}>
                    <Grid
                        order={{ xs: 1, md: 2 }}
                        size={{ xs: 12, md: 6, lg: 4 }}
                        display="flex"
                        className="rft_header_center"
                        justifyContent="center"
                        sx={{ position: "relative" }}
                    >
                        <div className="rft_mobile_hmenu_btn">
                            <IconButton
                                onClick={handleHamburgerClick}
                                aria-label="Mobile Menu Hamburger"
                            >
                                <MenuIcon
                                    sx={{ width: "40px", height: "40px" }}
                                />
                            </IconButton>
                        </div>
                        <div style={{ margin: "0 auto" }}>
                            <Link href={urlToHome} underline="none">
                                <h2 className="rft_header_title">
                                    Rossi Floor <br />
                                    Technologies
                                </h2>
                            </Link>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div className="rft_divider"></div>

            {/* Mobile Navigation */}
            <MobileMenu
                open={mobileMenuVisible}
                onClose={handleOutsideMenuClick}
                floorProducts={floorProducts}
                equipment={equipment}
                about={about}
                resources={resources}
            />
        </div>
    );
};

const DesktopNavMenu: React.FC = () => {
    return (
        <Box
            sx={{
                display: { xs: "none", md: "flex" },
                flexDirection: "row",
                alignItems: "stretch",
                justifyContent: "center",
                maxWidth: "1000px",
                width: "100%",
                margin: "12px"
            }}
        >
            <NavItem>
                <NavLink href={urlToHome}>Home</NavLink>
            </NavItem>
            <NavItem>
                <NavMenu title="Flooring Products" items={floorProducts} />
            </NavItem>
            <NavItem>
                <NavMenu title="Flooring Equipment" items={equipment} />
            </NavItem>
            <NavItem>
                <NavLink href={urlToRepairs}>
                    Equipment
                    <br />
                    Repair
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={urlToRentals}>
                    Equipment
                    <br />
                    Rental
                </NavLink>
            </NavItem>
            <NavItem>
                <NavMenu title="About &nbsp;" items={about} />
            </NavItem>
            <NavItem>
                <NavLink href={urlToContactUs}>Contact Us</NavLink>
            </NavItem>
            <NavItem>
                <NavMenu title="Resources &nbsp;" items={resources} />
            </NavItem>
        </Box>
    );
};
